/** @format */
import { MAX_SEARCH_ROWS } from './constants';
import { QueryResponse } from './types';

/**
 * Splits one large range into consecutive requests that each stay within the
 * rows cap, then merges them back into a single response in order. Deep linked
 * "view more" pages need every result up to the page, but the proxy rejects any
 * single request above the cap.
 */
export async function fetchSearchResultsInBatches<
    T extends QueryResponse<unknown>,
>(
    start: number,
    rows: number,
    fetchBatch: (batchStart: number, batchRows: number) => Promise<T>
): Promise<T> {
    const batchCount = Math.max(Math.ceil(rows / MAX_SEARCH_ROWS), 1);

    const responses = await Promise.all(
        Array.from({ length: batchCount }, (unusedItem, index) => {
            const offset = index * MAX_SEARCH_ROWS;

            return fetchBatch(
                start + offset,
                Math.min(MAX_SEARCH_ROWS, rows - offset)
            );
        })
    );

    return responses.reduce((merged, response) => ({
        ...merged,
        results: [...merged.results, ...response.results],
        resultCount: merged.resultCount + response.resultCount,
    }));
}
